import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { UserRole } from '@xtreed/academy-shared';

interface AdminRouteProps {
  children: React.ReactNode;
}

const adminRoles: UserRole[] = [UserRole.SUPER_ADMIN, UserRole.ADMIN];

export function AdminRoute({ children }: AdminRouteProps) {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user || !adminRoles.includes(user.role as UserRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
